
export enum MacroActionValueType {
  None = 'None',
  ShowValue = 'ShowValue',
  ShowValueNotifyMedication = 'ShowValueNotifyMedication',
  Close = 'Close',
  ShowWarning = 'ShowWarning',
  PickDate = 'PickDate',
  PersistentData = 'PersistentData',
}

export interface MacroActionValueDto {
  // this property can come from the server as null
  Value: string | null;

  MacroResultId: string;
  Action: MacroActionValueType;
}
